<template>
  <div class="content mt-5">
    <div class="container">
      <div class="row" id="alterarGrid">

        <div class="col-12 col-md-7 mb-4">
          <div class="row cardItem">
            <div class="col-10" @click="dadosPessoais = !dadosPessoais">
              <span class="fontTitle"><i class="fas fa-user mr-2"></i>Dados pessoais</span>
            </div>
            <div class="col-2 text-right" @click="dadosPessoais = !dadosPessoais">
              <span class="fontTitle">
                <i v-if="dadosPessoais" class="fas fa-arrow-up"></i><i v-if="!dadosPessoais" class="fas fa-arrow-down"></i>
              </span>
            </div>

            <div class="col-12" v-if="dadosPessoais">
              <div class="row mb-2">
                <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-2">
                  <label>CNPJ:</label>
                  <input type="text" class="form-control" v-model="fields.cnpj" v-mask="'##.###.###/####-##'" placeholder="##.###.###/####-##" @blur="buscarCnpj()">
                </div>

                <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-2">
                  <label>Razão social:</label>
                  <input type="text" class="form-control" v-model="fields.razao_social" placeholder="Informe a razão social">
                </div>

                <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-2">
                  <label>Nome fantasia:</label>
                  <input type="text" class="form-control" v-model="fields.nome_fantasia" placeholder="Informe o nome fantasia">
                </div>

                <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-2">
                  <label>WhatsApp:</label>
                  <input type="text" class="form-control" v-model="fields.celular" v-mask="['(##) ####-####', '(##) # ####-####']" placeholder="(##) # ####-####">
                </div>

                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2">
                  <label>Socio administrador:</label>
                  <input type="text" class="form-control" v-model="fields.nome_responsavel" placeholder="Informe o nome do socio responsavél">
                </div>

                <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-2">
                  <label>CPF:</label>
                  <input type="text" class="form-control" v-model="fields.cpf_socio" v-mask="'###.###.###-##'" placeholder="###.###.###-##">
                </div>

                <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-2">
                  <label>RG:</label>
                  <input type="text" class="form-control" v-model="fields.rg_socio" v-mask="'##.###.###-#'" placeholder="##.###.###-#">
                </div>

                <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-2">
                  <label>Cep:</label>
                  <input type="text" class="form-control" v-model="fields.cep" v-mask="'#####-###'" placeholder="#####-###" @change="consultCep()">
                </div>

                <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-2">
                  <label>Endereço:</label>
                  <input type="text" class="form-control" v-model="fields.endereco" placeholder="Informe o nome da rua">
                </div>

                <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-2">
                  <label>Bairro:</label>
                  <input type="text" class="form-control" v-model="fields.bairro" placeholder="Informe o bairro">
                </div>

                <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-2">
                  <label>Número:</label>
                  <input type="text" class="form-control" v-model="fields.numero" placeholder="Informe o número">
                </div>

                <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-2">
                  <label>Complemento:</label>
                  <input type="text" class="form-control" v-model="fields.complemento" placeholder="Informe o complemento">
                </div>

                <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-2">
                  <label>Cidade:</label>
                  <input type="text" class="form-control" v-model="fields.cidade" placeholder="Cidade" disabled>
                </div>

                <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-2">
                  <label>Estado:</label>
                  <input type="text" class="form-control" v-model="fields.estado" placeholder="UF" disabled>
                </div>

                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2">
                  <label>E-Mail:</label>
                  <input type="text" class="form-control" v-model="fields.email" placeholder="seuemail@email.com" @blur="buscarEmail()">
                </div>

                <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 mt-2">
                  <label>Senha:</label>
                  <input :type="showPassword ? 'text' : 'password'" class="form-control" v-model="fields.password" placeholder="########">
                  <span class="eyeInput" @click="showPassword = !showPassword">
                    <i class="fas fa-eye" v-if="showPassword"></i>
                    <i class="fas fa-eye-slash" v-else></i>
                  </span>
                </div>

                <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 mt-2">
                  <label>Repita a senha:</label>
                  <input :type="reShowPassword ? 'text' : 'password'" class="form-control" v-model="fields.repassword" placeholder="########">
                  <span class="eyeInput" @click="reShowPassword = !reShowPassword">
                    <i class="fas fa-eye" v-if="reShowPassword"></i>
                    <i class="fas fa-eye-slash" v-else></i>
                  </span>
                </div>

                <div class="col-12 text-center mt-4">
                  <button class="btn-avancar blockBtnShow" @click="avancarMethods('frete')">
                    CONTINUAR
                    <i class="fas fa-arrow-right ml-2"></i>
                  </button>                      
                </div>
              </div>
            </div>
          </div>

          <div class="row cardItem mt-4">
            <div class="col-10" @click="dadosPagamento = !dadosPagamento">
              <span class="fontTitle"><i class="fas fa-money-check mr-2"></i>Opções de pagamento</span>
            </div>
            <div class="col-2 text-right" @click="dadosPagamento = !dadosPagamento">
              <span class="fontTitle">
                <i v-if="dadosPagamento" class="fas fa-arrow-up"></i><i v-if="!dadosPagamento" class="fas fa-arrow-down"></i>
              </span>
            </div>

            <div class="col-12" v-if="dadosPagamento">
              <div class="row">
                <div class="col-12 mt-2">
                  <h5 class="text-center mt-4">Selecione o meio de pagamento abaixo</h5>
                  <p class="text-center">
                    <strong>Data da primera parcela: </strong>{{ formatDate(assinatura.data_pagamento) }}
                  </p>
                  <b-button-group class="d-flex justify-content-around mb-3 mt-2">
                    <b-button 
                      v-if="assinatura.forma_pagamento == TypePayment.TODOS || 
                        assinatura.forma_pagamento == TypePayment.CARTAO ||
                        assinatura.forma_pagamento == TypePayment.PIX_CARTAO ||
                        assinatura.forma_pagamento == TypePayment.BOLETO_CARTAO
                      "
                      variant="dark" 
                      class="mt-2" 
                      block 
                      :class="pagamentoSelecionado == 'cartao' ? 'success' : ''" 
                      @click="pagamentoSelecionado = 'cartao', selectCard()"
                    >
                    <i class="fas fa-credit-card mr-2"></i>
                      Cartão de crédito
                    </b-button>

                    <b-button 
                      v-if="assinatura.forma_pagamento == TypePayment.TODOS || 
                        assinatura.forma_pagamento == TypePayment.PIX ||
                        assinatura.forma_pagamento == TypePayment.PIX_CARTAO ||
                        assinatura.forma_pagamento == TypePayment.PIX_BOLETO
                      "
                      variant="dark" 
                      class="mx-1" 
                      block 
                      :class="pagamentoSelecionado == 'pix' ? 'success' : ''" 
                      @click="pagamentoSelecionado = 'pix'"
                    >
                      <span class="mr-2">
                        <svg 
                          height="1em"
                          viewBox="0 0 512 512"
                          xmlns="http://www.w3.org/2000/svg" 
                        >
                          <path d="M242.4 292.5C247.8 287.1 257.1 287.1 262.5 292.5L339.5 369.5C353.7 383.7 372.6 391.5 392.6 391.5H407.7L310.6 488.6C280.3 518.1 231.1 518.1 200.8 488.6L103.3 391.2H112.6C132.6 391.2 151.5 383.4 165.7 369.2L242.4 292.5zM262.5 218.9C256.1 224.4 247.9 224.5 242.4 218.9L165.7 142.2C151.5 127.1 132.6 120.2 112.6 120.2H103.3L200.7 22.8C231.1-7.6 280.3-7.6 310.6 22.8L407.8 119.9H392.6C372.6 119.9 353.7 127.7 339.5 141.9L262.5 218.9zM112.6 142.7C126.4 142.7 139.1 148.3 149.7 158.1L226.4 234.8C233.6 241.1 243 245.6 252.5 245.6C261.9 245.6 271.3 241.1 278.5 234.8L355.5 157.8C365.3 148.1 378.8 142.5 392.6 142.5H430.3L488.6 200.8C518.9 231.1 518.9 280.3 488.6 310.6L430.3 368.9H392.6C378.8 368.9 365.3 363.3 355.5 353.5L278.5 276.5C264.6 262.6 240.3 262.6 226.4 276.6L149.7 353.2C139.1 363 126.4 368.6 112.6 368.6H80.8L22.8 310.6C-7.6 280.3-7.6 231.1 22.8 200.8L80.8 142.7H112.6z"/>
                        </svg>
                      </span>
                      Pix
                    </b-button>

                    <b-button
                      v-if="assinatura.forma_pagamento == TypePayment.TODOS || 
                        assinatura.forma_pagamento == TypePayment.BOLETO ||
                        assinatura.forma_pagamento == TypePayment.BOLETO_CARTAO ||
                        assinatura.forma_pagamento == TypePayment.PIX_BOLETO
                      "
                      variant="dark" 
                      block 
                      :class="pagamentoSelecionado == 'boleto' ? 'success' : ''" 
                      @click="pagamentoSelecionado = 'boleto'"
                    >
                    <i class="fas fa-barcode mr-2"></i>
                      Boleto
                    </b-button>
                  </b-button-group>
                  <div 
                    class="row mb-2 mt-5" 
                    :style="pagamentoSelecionado == 'cartao' ? 'display:block' : 'display:none'"
                  >
                    <div class="col-12 formatCardCenter">
                      <div class="card-wrapper mb-5"></div>
                    </div>

                    <div id="cc-form" class="col-12 mb-3">
                      <div class="row">
                        <div class="col-12 col-md-12">
                          <label>Número do cartão</label>
                          <input class="form-control mb-3" id="cc-number" type="text" name="number" v-model="number" placeholder="xxxx - xxxx - xxxx - xxxx">
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-12 col-md-6">
                          <label>Nome</label>
                          <input class="form-control mb-3" id="ccName" type="text" name="ccName" v-model="ccName" placeholder="Digite o seu nome">
                        </div>

                        <div class="col-12 col-md-6">
                          <label>Sobrenome</label>
                          <input class="form-control mb-3" id="last-name" type="text" name="last-name" v-model="lastname" placeholder="Digite o seu sobrenome">
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-6 col-md-4">
                          <label>Mês de expiração</label>
                          <input class="form-control mb-3" id="cc-expiration" type="text" name="expiry" v-model="month" placeholder="xx"  maxlength="2">
                        </div>

                        <div class="col-6 col-md-4">
                          <label>Ano de expiração</label>
                          <input class="form-control mb-3" id="cc-expiration" type="text" name="expiry" v-model="year" placeholder="xxxx" maxlength="4">
                        </div>

                        <div class="col-12 col-md-4">
                          <label>CVV</label>
                          <input class="form-control mb-3" id="cc-cvv" type="text" name="cvc" v-model="cvv" placeholder="xxx" maxlength="4" @focus="validCVC('back')" @blur="validCVC('front')">
                        </div>

                        <div class="col-12 text-center mt-2">
                          <button class="btn-avancar blockBtn" @click="avancarMethods('pagamento')">
                            FINALIZAR<i class="fas fa-arrow-right ml-2"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 text-center mt-2" v-if="pagamentoSelecionado != 'cartao' && pagamentoSelecionado != ''">
                    <button 
                      class="btn-avancar blockBtn" 
                      @click="avancarMethods('pagamento')">
                      FINALIZAR
                      <i class="fas fa-arrow-right ml-2"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 col-md-5">
          <div class="row cardItemRow cardItem">
            <div class="col-12">
              <span class="fontTitle"><i class="fas fa-th-list mr-2"></i>Resumo</span>
            </div>
            
            <div class="col-12">
              <div class="row cardProduto mt-2">
                <div class="col-3 cardProdutoImg">
                  <img src="https://www.remessaonline.com.br/blog/wp-content/uploads/2022/04/redes-sociais-mais-usadas.jpg" class="imgProduto" alt="Assinatura">
                </div>
                <div class="col-9">
                  <p style="font-size: 14px;padding-bottom: 10px;"><b>{{assinatura.nome}}</b></p>
                  <div class="row fontSelectPro">
                    <div class="col-12">
                      <span><b>Preço: {{assinatura.preco_formatado}}</b></span>
                    </div>
                    <div class="col-12">
                      <p>{{assinatura.descricao}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 mt-4 cardSoma">
              <div class="row mt-3 totalFinal">
                <div class="col-6">
                  <b>Total</b>
                </div>
                <div class="col-6 text-right">
                  <span>{{assinatura.preco_formatado}}</span>
                </div>
              </div>

              <div class="row mt-2">
                  <div class="col-12 text-center mt-2">
                    <button class="btn-avancar blockBtnShow blockBtnHide" @click="avancarMethods('pagamento')">
                      FINALIZAR
                      <i class="fas fa-arrow-right ml-2"></i>
                    </button>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      title="Confirmação de pagamento"
      size="md"
      id="pagamentoCartaoModal"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
    >
      <div class="row" v-if="pagamentoCartao == false">
        <div class="col-md-12 text-center mt-4 mb-4">
          <span class="checkNo"><i class="fas fa-times"></i></span>
        </div>

        <div class="col-md-12 text-center mt-4">
          <h4>Pagamento negado, confirme os dados acima e tente novamente!</h4>
        </div>
      </div>
    </b-modal>

    <b-modal
      title="Pagamento por PIX"
      size="md"
      id="pagamentoPixModal"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
    >
      <div class="row">
        <div class="col-md-12 text-center">
          <img :src="qr_code" alt="Qr Code">
        </div>

        <div class="col-md-12">
          <textarea class="form-control" rows="4" :value="qrcode_text" readonly></textarea>

          <button class="btn btn-primary btn-block mt-2 mb-2" @click="copyToClipboard()">
            Copiar qr code pix
          </button>
        </div>

        <div class="col-md-12">
          <button class="btn btn-success btn-block" @click="validarPagamento()">
            Já realizei o pagamento!
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal
      title="Pagamento por Boleto"
      size="md"
      id="pagamentoBoletoModal"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
    >
      <div class="row">
        <div class="col-md-12 text-center">
          Realize o pagamento
        </div>

        <div class="col-md-6 mt-4">
          <button class="btn btn-primary btn-block mt-2 mb-2" @click="copyToClipboard()">
            <i class="fas fa-barcode mr-2"></i>
            Copiar código de barras
          </button>
        </div>

        <div class="col-md-6 mt-4">
          <button class="btn btn-primary btn-block mt-2 mb-2" @click="openToBankSlip()">
            <i class="fas fa-location-arrow mr-2"></i>
            Abrir boleto
          </button>
        </div>

        <div v-if="!gerou_boleto" class="col-md-12 mt-2">
          <button class="btn btn-success btn-block" @click="gerou_boleto = true">
            Continuar
          </button>
        </div>

        <div v-if="gerou_boleto" class="col-md-12 mt-4">
          <h4 class="text-center">
            Favor entrar em contato com seu gerente de conta, informando que já foi gerado o boleto de pagamento
          </h4>

          <b-button variant="danger" class="mt-4" block @click="closeModal()">Sair</b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script type="text/javascript" src="https://js.iugu.com/v2"></script>
<script>
import * as Card from 'card';
import makeToast from "../mixins/makeToast";
import QrcodeVue from 'qrcode.vue';
import login from '@/mixins/login';
import TypePayment from "@/enums/TypePayment";
export default {
  name: 'CadastroPaymentsAssinatura',
  mixins: [makeToast, login],

  components: {
    QrcodeVue
  },

  data() {
    return {
      TypePayment,
      fields: {
        cnpj: '',
        razao_social: '',
        nome_fantasia: '',
        nome_responsavel: '',
        rg_socio: '',
        cpf_socio: '',
        celular: '',
        password: '',
        repassword: '',
        email: '',
        cep: '',
        endereco: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidade: '',
        cidade_id: '',
        estado: '',
        tipo_pagamento: '',
        plano: 3,
        tipo_usuario_id: 3
      },
      assinatura: {
        nome: '',
        preco_formatado: '',
        descricao: '',
        forma_pagamento: null,
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: true,
      },
      fatura: '',
      qr_code: '',
      qrcode_text: '',
      barcode: '',
      barcode_text: '',
      dadosPessoais: true,
      dadosPagamento: false,
      pagamentoCartao: false,
      size: 250,
      showPassword: false,
      reShowPassword: false,
      pagamentoSelecionado: '',
      number: '',
      ccName: '',
      lastname: '',
      month: '',
      year: '',
      cvv: '',
      months: '',
      classCard: '',
      valid: false,
      printRadio: '<input type="radio" class="mr-2">',
      gerou_boleto: false,
    }
  },

  watch: {
    'ccName': function () {
      const name = document.querySelectorAll('.jp-card-name');
      const nameFull = this.ccName +' '+ this.lastname;
      name[0].innerText = nameFull;
    },
    'lastname': function () {
      const name = document.querySelectorAll('.jp-card-name');
      const nameFull = this.ccName +' '+ this.lastname;
      name[0].innerText = nameFull;
    },
    'month': function () {
      if(this.month > 12) {
        this.makeToast('Oopss!', 'Mês invalido!', 'danger');
        this.month = '';
      } else {
        const cardExpiry = document.querySelectorAll('.jp-card-expiry');
        const cardFull = this.month +'/'+ this.year;
        cardExpiry[0].innerText = cardFull;
      }
    },
    'year': function () {
      if((this.year.length == 4) && (this.year < 2023 || this.year > 2040)) {
        this.makeToast('Oopss!', 'Ano invalido!', 'danger');
        this.year = '';
      } else {
        const cardExpiry = document.querySelectorAll('.jp-card-expiry');
        const cardFull = this.month +'/'+ this.year;
        cardExpiry[0].innerText = cardFull;
      }
    },
    'cvv': function () {
      const cvv = document.querySelectorAll('.jp-card-cvc');
      cvv[1].innerText = this.cvv;
    }
  },

  mounted() {
    if(this.$route.params.id) {
      this.buscarAssinatura();

      let Script = document.createElement('script');
      Script.setAttribute('src', 'https://js.iugu.com/v2');
      document.head.appendChild(Script);      
    }
  },

  methods: {
    selectCard() {
      new Card({
        form: 'div#cc-form',
        container: '.card-wrapper',
        formSelectors: {
          numberInput: 'input#cc-number',
          nameInput: 'input#ccName',
          expiryInput: 'input#cc-month, input#cc-year',
          cvcInput: 'input#cc-cvv',
        },
        width: 370,
        formatting: true,
        messages: {
          validDate: 'valido\ndata',
          monthYear: 'mm/yyyy',
        },
        placeholders: {
          number: '•••• •••• •••• ••••',
          name: 'Nome completo',
          expiry: '••/••',
          cvc: '•••',
        },
      });
    },
    validCVC(type) {
      const front = document.querySelectorAll('.jp-card')
      if (type == 'back') {
        this.classCard = front[0].className;
        front[0].className = 'jp-card jp-card-flipped';
      }
      if (type == 'front') {
        front[0].className = this.classCard;
      }
    },
    buscarAssinatura() {
      this.loading = true;
      this.$store.dispatch('startLoader');
      this.$store.dispatch('buscarDadosAssinatura', atob(this.$route.params.id))
        .then(async (response) => {
          this.assinatura = response.data;
        })
        .catch(() => {
          this.data = null;
          this.makeToast('Oopss!', 'Assinatura não encontrada!', 'danger');
        })
        .finally(() => {
          this.loading = false;
          this.$store.dispatch('endLoader');
        })
    },
    consultCep() {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('user/consultCep', this.fields.cep)
        .then(async (response) => {
          if(response.data.uf) {
            this.fields.endereco = response.data.logradouro;
            this.fields.bairro = response.data.bairro;
            this.fields.cidade = response.data.localidade;
            this.fields.cidade_id = response.data.cidade_id;
            this.fields.estado = response.data.uf;
          } else {
            this.fields.cep = '';
            this.fields.endereco = '';
            this.fields.bairro = '';
            this.fields.numero = '';
            this.fields.complemento = '';
            this.fields.cidade = '';
            this.fields.cidade_id = '';
            this.fields.estado = '';
          }
        })
        .catch((error) => {
          this.makeToast('Oopss!', error.response.data.message, 'danger');
        })
        .finally(() => {
          this.loading = false;
          this.$store.dispatch('endLoader');
        });
    },
    buscarCnpj() {
      const cnpj = this.fields.cnpj.replace(/[^0-9]/g, '');

      this.$store.dispatch('startLoader');
      this.$store.dispatch('user/validarCnpj', cnpj)
        .then(async (response) => {
          if(response.data.valid == true) {
            this.fields.cnpj = '';
            this.makeToast('Oopss!', 'Esse CNPJ já está sendo utilizado, informe outro!', 'danger');
          }
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        })
    },
    buscarEmail() {
      const data = {
        email: this.fields.email
      }

      this.$store.dispatch('startLoader');
      this.$store.dispatch('user/validarEmail', data)
        .then(async (response) => {
          if(response.data.valid == true) {
            this.fields.email = '';
            this.makeToast('Oopss!', 'Esse E-Mail já está sendo utilizado, informe outro!', 'danger');
          }
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        })
    },
    validarPagamento() {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/verifyPaymentAppPix', this.fatura)
        .then(async (response) => {
          if(response.data.status == 'externally_paid' || response.data.status == 'paid') {
            this.makeToast('Sucesso!', 'O cadastro do lojista foi realizado com sucesso!', 'success');
            this.delayedLogin();
          } else {
            this.makeToast('Oopss!', 'Pagamento negado, caso já tenha feito o pagamento, tente validar novamente!', 'danger');
          }
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        })
    },
    avancarMethods(type) {
      if(type == 'pessoais') {
        this.dadosPessoais = false;
        this.dadosPagamento = false;
      } else if (type == 'frete') {
        this.dadosPessoais = false;
        this.dadosPagamento = true;
      } else if(type == 'pagamento') {        
        const valid = this.validForm();
        
        if(valid == false) return;

        this.fields.tipo_pagamento = this.pagamentoSelecionado;

        const data = {
          usuario: this.fields,
          plano: this.assinatura
        }

        this.$store.dispatch('startLoader');
        if(this.pagamentoSelecionado == 'cartao') {
          this.criarToken(data);
        } else if(this.pagamentoSelecionado == 'pix' || this.pagamentoSelecionado == 'boleto') {
          this.criarConta(data);
        }
      }
    },
    criarToken(data) {

      Iugu.setAccountID('D9BC3DAFD6314DE2B01323646B94F29B');
      Iugu.setup();
      Iugu.setTestMode(false);

      const cc = Iugu.CreditCard(
        this.number,
        this.month,
        this.year,
        this.ccName,
        this.lastname,
        this.cvv
      );
      Iugu.createPaymentToken(cc, (response) => {
        if (response.errors) {
          this.makeToast('Oops!', 'Não foi possível salvar o cartão', 'danger');
          this.$store.dispatch('endLoader');
        } else {

          data.token = response.id;
          
          this.criarConta(data);
        }
      });
    },
    copyToClipboard() {
      if(this.pagamentoSelecionado == 'pix') {
        navigator.clipboard.writeText(this.qrcode_text);
      } else {
        navigator.clipboard.writeText(this.barcode_text);
      }
      this.makeToast('Sucesso!', 'Copiado com sucesso!', 'success');
    },
    openToBankSlip() {
      window.open(`${this.barcode}.pdf`, "_blank");
    },
    criarConta(data) {
      this.$store.dispatch('shopkeeper/registerAssDemo', data)
        .then((response) => {
          if(this.pagamentoSelecionado == 'cartao') {
            if(response.data.error == false) {
              this.makeToast('Sucesso!', 'O cadastro do lojista foi realizado com sucesso!', 'success');
              this.delayedLogin();
            } else {
              this.$bvModal.show('pagamentoCartaoModal');
              this.makeToast('Oopss!', 'Pagamento negado, confirme os dados acima e tente novamente!', 'danger');
            }
          } else if(this.pagamentoSelecionado == 'pix') {
            this.qr_code = response.data.result.qrcode;
            this.qrcode_text = response.data.result.qrcode_text;
            this.fatura = response.data.fatura;

            this.$bvModal.show('pagamentoPixModal');
          } else if(this.pagamentoSelecionado == 'boleto') {
            this.barcode = response.data.result.secure_url;
            this.barcode_text = response.data.result.bank_slip.digitable_line;

            this.$bvModal.show('pagamentoBoletoModal');
          }
        })
        .catch(() => {
          this.makeToast('Oopss!', 'Erro ao finalizar pedido', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        })
    },
    delayedLogin() {
      setTimeout(() => {
        this.login(this.fields.email, this.fields.password, false, true);
      }, 1000);
    },
    closeModal() {
      this.$bvModal.hide('pagamentoBoletoModal');
      this.$router.push({ name: 'home' });
    },
    validForm() {
      var valid = true;

      if(this.fields.cnpj == ''){
        this.makeToast( 'Erro', 'Informe o CNPJ!', 'danger');
        valid = false;
      }

      if(this.fields.razao_social == ''){
        this.makeToast( 'Erro', 'Informe a razão social!', 'danger');
        valid = false;
      }

      if(this.fields.nome_fantasia == ''){
        this.makeToast( 'Erro', 'Informe o nome fantasia!', 'danger');
        valid = false;
      }

      if(this.fields.celular == ''){
        this.makeToast( 'Erro', 'Informe o WhatsApp!', 'danger');
        valid = false;
      }

      if(this.fields.nome_responsavel == ''){
        this.makeToast( 'Erro', 'Informe o nome do responsável!', 'danger');
        valid = false;
      }

      if(this.fields.cpf_socio == ''){
        this.makeToast( 'Erro', 'Informe o CPF!', 'danger');
        valid = false;
      }

      if(this.fields.rg_socio == ''){
        this.makeToast( 'Erro', 'Informe o RG!', 'danger');
        valid = false;
      }

      if(this.fields.cep == ''){
        this.makeToast( 'Erro', 'Informe o cep!', 'danger');
        valid = false;
      }

      if(this.fields.endereco == ''){
        this.makeToast( 'Erro', 'Informe o endereco!', 'danger');
        valid = false;
      }

      if(this.fields.numero == ''){
        this.makeToast( 'Erro', 'Informe o numero!', 'danger');
        valid = false;
      }

      if(this.fields.bairro == ''){
        this.makeToast( 'Erro', 'Informe o bairro!', 'danger');
        valid = false;
      }

      if(this.fields.email == ''){
        this.makeToast( 'Erro', 'Informe o email!', 'danger');
        valid = false;
      }

      if(this.fields.password == ''){
        this.makeToast( 'Erro', 'Informe a senha!', 'danger');
        valid = false;
      }

      if(this.fields.repassword == '' ){
        this.makeToast( 'Erro', 'Repita sua senha!', 'danger');
        valid = false;
      }

      if(this.fields.repassword != '' && this.fields.password != this.fields.repassword){
        this.makeToast( 'Erro', 'As senhas não são iguais!', 'danger');
        valid = false;
      }

      if(this.pagamentoSelecionado == ''){
        this.makeToast( 'Erro', 'Selecione um meio de pagamento!', 'danger');
        valid = false;
      }

      if(this.pagamentoSelecionado == 'cartao') {
        if(this.number == '') {
          this.makeToast('Oops!', 'Preencha o número do seu cartão!', 'danger');
          valid = false;
        }
        if(this.ccName == '') {
          this.makeToast('Oops!', 'Informe seu nome!', 'danger');
          valid = false;
        }
        if(this.lastname == '') {
          this.makeToast('Oops!', 'Informe seu sobrenome!', 'danger');
          valid = false;
        }
        if(this.month == '') {
          this.makeToast('Oops!', 'Informe o mês da validade do seu cartão!', 'danger');
          valid = false;
        }
        if(this.year == '') {
          this.makeToast('Oops!', 'Informe o ano da validade do seu cartão!', 'danger');
          valid = false;
        }
        if(this.cvv == '') {
          this.makeToast('Oops!', 'Informe o cvv do seu cartão!', 'danger');
          valid = false;
        }
      }
      return valid;
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString('pt-BR', { timeZone: 'UTC' });
    },
  }
}
</script>
<style scoped>
.cardSoma {
  background: #f4f6f8;
  padding: 25px;
  border-radius: 3px;
}
.cardProdutoImg {
  text-align: center;
  justify-content: center;
  align-items: center;
  display: flex;
}
.selecionaQtd {
  border: 1px solid #dfdfdf;
  border-radius: 3px;
  cursor: pointer;
}
.cardProduto {
  border: 1px solid #dfdfdf;
  border-radius: 3px;
  padding: 15px 0;
}
.imgProduto {
  width: 80px;
}
.cardEndHeader {
  border: 1px solid #dfdfdf;
  border-radius: 3px;
  padding: 10px 5px;
  text-align: left;
  min-height: 160px;
}
.titleEnd {
  background-color: #3a3939;
  color: #FFF;
}
.fontTitle {
  font-size: 1.5rem;
  color: #222;
  cursor: pointer;
}
.cursor-pointer{
  cursor: pointer;
}
.cardItem {
  background-color: #FFF;
  border-radius: 3px;
  padding: 10px 10px;
}
.content {
  background-color: #f4f6f8;
  min-height: 100vh;
  padding: 40px 10px;
}
.header {
  height: 80px;
  background: #FFF;
  box-shadow: 0 0 2px 0 hsla(0,0%,80%,.5);
  color: #898792;
  display: flex;
  align-items: center;
}
.footer {
  height: 80px;
  background: #f4f6f8;
  box-shadow: 0 0 2px 0 hsla(0,0%,80%,.5);
}
.logo {
  max-width: 165px;
  max-height: 70px;
}
.pagamentoSeguro {
  display: flex;
  justify-content: right;
  align-items: center;
}
.btn-avancar {
  background: #3fc583;
  color: #FFF;
  height: 50px;
  width: 200px;
  border: none;
  border-radius: 3px;
  font-size: 18px;
  font-weight: 900;
}
.btn-avancar:hover {
  background: #3fc582bb;
}
.btn-avancar:disabled {
  background: #63f0a9bb;
}
.success {
  background: #3fc583 !important;
}
.totalFinal {
  color: #3fc583;
  font-weight: 900;
  font-size: 22px;
}
.formatCardCenter {
  display: flex;
  align-items: center;
  justify-content: center;
}
.cardQr {
  justify-content: center;
  display: flex;
  align-items: center;
}
.btn-send-payment {
  margin-top: 20px;
  width: 100%;
  padding: 15px 0;
  background: #3fc583;
  color: #FFF;
  font-weight: bold;
  font-size: 18px;
  border: none;
  border-radius: 3px;
}
.checkYes {
  font-size: 100px;
  color: #3fc583;
  border: 10px solid #3fc583;
  border-radius: 50%;
  padding: 0 25px;
}
.checkNo {
  font-size: 100px;
  color: #ed6262;
  border: 10px solid #ed6262;
  border-radius: 50%;
  padding: 0 40px;
}
.eyeInput {
  position: absolute;
  right: 25px;
  top: 39px;
}
/* #alterarGrid {
  flex-direction: row-reverse;
} */
@media screen and (min-width: 768px) {
  .cardItemRow {
    margin-left: 0.5rem !important;
  }
  .blockBtnHide {
    display: none;
  }
}
@media screen and (max-width: 767px) {
  .blockBtn {
    display: none;
  }
  .blockBtnShow {
    width: 100%;
  }
  .logo {
    max-width: 135px;
  }
  .fontSelectPro {
    font-size: 14px;
  }
}
</style>
